import React, { useEffect, useState } from 'react';
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  UncontrolledButtonDropdown,
  UncontrolledTooltip,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Router, { useRouter } from 'next/router';

import {
  changeViewMode,
  getViewMode,
  logout,
  setShouldDisconnectSocket,
  setTempUserToken,
} from 'store/auth/index';
import useI18n from 'hooks/use-i18n';
import {
  ARR_USER_ROLES,
  TEMP_USER_TOKEN,
  USER_TOKEN,
  USER_VIEW_MODE,
  SELECTED_CENTRES,
} from 'helpers/storage';
import { RotateCcw } from 'react-feather';
import styles from 'styles/Header.module.scss';
import classnames from 'classnames';
import Avatar from '../Avatar/Avatar';
import { USER_ROLES } from '../../../constants/constants';
import { useTempUserToken, useUser } from '../../../hooks';
import { DOMAIN_HOST } from '../../../config';
import { fetchLearnerData } from 'store/units';
import { getThemeColor, getColorMenu } from 'store/settings';
import styled from '@emotion/styled';
import settingAccountApi from 'api/settingAccountApi';
import { setSelectedCentre } from 'store/master';
import {
  MdOutlineLocalActivity,
  MdOutlineNotifications,
  MdOutlineSettings,
  MdPersonOutline,
  MdOutlinePowerSettingsNew,
  MdHistory,
} from 'react-icons/md';

const ProfileAvatar = () => {
  const dispatch = useDispatch();
  const i18n = useI18n();
  const tempUserToken = useTempUserToken();
  const viewMode = useSelector(getViewMode);
  const user = useUser();
  const { roles } = user;
  const router = useRouter();
  //color theme
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const themeStatus = useSelector(getThemeColor);
  const menuColor = useSelector(getColorMenu);
  const Stylescal = styled.div`
    input[type='radio']:checked {
      background-color: ${themeStatus};
      border: 1px solid ${themeStatus};
    }
    .profile-display:hover,
    .proile-display:focus {
      color: ${menuColor};
    }
  `;
  const [isAdmin, setIsAdmin] = useState(false);
  const [isInstructor, setInstructor] = useState(false);
  const [isLearner, setIsLearner] = useState(false);
  const [isPurchaseHistory, setIsPurchaseHistory] = useState(false);
  const [isCoupon, setIsCoupon] = useState(false);
  const [isNotification, setIsNotification] = useState(false);
  const [isAccountSetting, setIsAccountSetting] = useState(false);
  const [isProfile, setIsProfile] = useState(false);
  const [isLogout, setIsLogout] = useState(false);

  const profileMenuHandler = async (type) => {
    switch (type) {
      case 'purchaseHistory-hover':
        setIsPurchaseHistory(false);
        router.push('/homes/purchaseHistory');
        break;
      case 'coupon-hover':
        setIsCoupon(false);
        router.push('/homes/addCoupon');
        break;
      case 'notification-hover':
        setIsNotification(false);
        router.push('/notification');
        break;
      case 'accountSettings-hover':
        setIsAccountSetting(false);
        router.push('/account-settings');
        break;
      case 'profile-hover':
        setIsProfile(false);
        router.push('/profile');
        break;
      case 'logout-hover':
        setIsLogout(false);
        break;
    }
  };
  const handleMouseEnter = async (type) => {
    switch (type) {
      case 'admin-hover':
        setIsAdmin(true);
        break;
      case 'instructor-hover':
        setInstructor(true);
        break;
      case 'learner-hover':
        setIsLearner(true);
        break;
      case 'purchaseHistory-hover':
        setIsPurchaseHistory(true);
        break;
      case 'coupon-hover':
        setIsCoupon(true);
        break;
      case 'notification-hover':
        setIsNotification(true);
        break;
      case 'accountSettings-hover':
        setIsAccountSetting(true);
        break;
      case 'profile-hover':
        setIsProfile(true);
        break;
      case 'logout-hover':
        setIsLogout(true);
        break;
    }
  };
  const handleMouseLeave = async (type) => {
    switch (type) {
      case 'admin-hover':
        setIsAdmin(false);
        break;
      case 'instructor-hover':
        setInstructor(false);
        break;
      case 'learner-hover':
        setIsLearner(false);
        break;
      case 'purchaseHistory-hover':
        setIsPurchaseHistory(false);
        break;
      case 'coupon-hover':
        setIsCoupon(false);
        break;
      case 'notification-hover':
        setIsNotification(false);
        break;
      case 'accountSettings-hover':
        setIsAccountSetting(false);
        break;
      case 'profile-hover':
        setIsProfile(false);
        break;
      case 'logout-hover':
        setIsLogout(false);
        break;
    }
  };

  async function handleLogout() {
    sessionStorage.removeItem('breadCrumb');
    dispatch(setSelectedCentre(undefined));
    await SELECTED_CENTRES.delete();

    if (metaData?.cmsHomePage == true) {
      await router.push(`/homeCms`);
      // window.open(`${DOMAIN_HOST}homeCms`, '_self');
    } else {
      await router.push(`/login`);
      // window.open(`${DOMAIN_HOST}login`, '_self');
    }

    await dispatch(setShouldDisconnectSocket());
    // window.open(`${DOMAIN_HOST}home`, '_self');

    dispatch(logout());
    await USER_TOKEN.delete();
    await USER_VIEW_MODE.delete();
    await ARR_USER_ROLES.delete();
    await TEMP_USER_TOKEN.delete();
  }

  function handleChangeMode(mode) {
    dispatch(changeViewMode(mode));
    dispatch(fetchLearnerData());
    if (mode !== viewMode) {
      router.push('/');
    }
  }

  async function backToAdmin() {
    sessionStorage.removeItem('breadCrumb');
    dispatch(setSelectedCentre(undefined));
    await SELECTED_CENTRES.delete();
    await USER_VIEW_MODE.delete();
    await dispatch(setTempUserToken(''));
    window.open(`${DOMAIN_HOST}`, '_self');
  }

  return (
    <div className="flexRow align-items-center profiledrop header-dropdown-icon profile-icon">
      <UncontrolledButtonDropdown className="header__nav-link header__nav-link--avatar">
        <DropdownToggle
          id="dropdownUser"
          name="dropdownUser"
          color="flat-secondary"
          className="py-05"
          style={{ minHeight: 31.3 }}
          variant="none"
        >
          <div className="chat-icon-res">
            <Avatar
              size={50}
              source={user?.avatar}
              className="header__avatar-group--image "
            />
          </div>
          <Label
            className="ml-2 mb-0 flexRow align-items-center chat-icon-mobile"
            for="dropdownUser"
          >
            <div
              className={classnames(
                'row',
                'profile-menu',
                styles['profile-menu'],
              )}
            >
              <Avatar
                size={50}
                source={user?.avatar}
                className="header__avatar-group--image"
              />
              <div className="col" style={{ marginTop: '5%' }}>
                <div>
                  <span
                    className="profile-response-name"
                    style={{ fontWeight: 'normal' }}
                  >
                    {user?.fullName}
                  </span>{' '}
                  | <strong>{i18n.t(viewMode?.toLowerCase())}</strong>
                </div>
                <div className="profile-response-email">
                  <span style={{ fontWeight: 'normal' }}>{user?.email}</span>
                </div>
                <div className="profile-response-email">
                  <span style={{ fontWeight: 'normal' }}>
                    {user?.type?.name == USER_ROLES.SUPER_ADMIN
                      ? 'SUPER ADMIN'
                      : user?.type?.name}
                  </span>
                </div>
              </div>
            </div>
          </Label>
        </DropdownToggle>

        <DropdownMenu
          className={classnames(
            'profile-menu-scroll',
            'profile-avatar-res',
            styles['profile-menu-scroll'],
            styles['profile-avatar-res'],
          )}
        >
          <Label
            className="ml-05 mb-0 flexRow align-items-center"
            for="dropdownUser"
          >
            <div
              className={classnames(
                'row',
                'profile-menu',
                styles['profile-menu'],
              )}
            >
              <Avatar
                size={50}
                source={user?.avatar}
                className="header__avatar-group--image"
              />
              <div className="col" style={{ marginTop: '3%' }}>
                <div>
                  <span style={{ fontWeight: 'normal' }}>{user?.fullName}</span>{' '}
                  | <strong>{i18n.t(viewMode?.toLowerCase())}</strong>
                </div>
                <div>
                  <span style={{ fontWeight: 'normal' }}>{user?.email}</span>
                </div>
                <div className="profile-response-email">
                  <span style={{ fontWeight: 'normal' }}>
                    {user?.type?.name == USER_ROLES.SUPER_ADMIN
                      ? 'SUPER ADMIN'
                      : user?.type?.name}
                  </span>
                </div>
              </div>
            </div>
          </Label>
          <hr />
          {roles?.length > 1 &&
          (roles?.indexOf(USER_ROLES.ADMIN) !== -1 ||
            roles?.indexOf(USER_ROLES.SUPER_ADMIN) !== -1) ? (
            <>
              <DropdownItem
                tag="a"
                onClick={() => handleChangeMode(USER_ROLES.ADMIN)}
              >
                <Stylescal>
                  <FormGroup check inline>
                    <Label
                      className="profile-display"
                      check
                      // style={{
                      //   color: isAdmin ? menuColor : '',
                      // }}
                      // onMouseEnter={() => handleMouseEnter('admin-hover')}
                      // onMouseLeave={() => handleMouseLeave('admin-hover')}
                    >
                      <Input
                        type="radio"
                        name="viewAdmin"
                        defaultChecked={viewMode === USER_ROLES.ADMIN}
                      />{' '}
                      <span
                        className={classnames(
                          'avatar-menu',
                          styles['avatar-menu'],
                        )}
                      >
                        Admin
                      </span>
                    </Label>
                  </FormGroup>
                </Stylescal>
              </DropdownItem>
            </>
          ) : null}

          {roles?.length > 1 &&
          roles?.indexOf(USER_ROLES.CENTRE_ADMIN) !== -1 ? (
            <>
              <DropdownItem
                tag="a"
                onClick={() => handleChangeMode(USER_ROLES.CENTRE_ADMIN)}
              >
                <Stylescal>
                  <FormGroup check inline>
                    <Label
                      className="profile-display"
                      check
                      // style={{
                      //   color: isLearner ? menuColor : '',
                      // }}
                      // onMouseEnter={() => handleMouseEnter('learner-hover')}
                      // onMouseLeave={() => handleMouseLeave('learner-hover')}
                    >
                      <Input
                        type="radio"
                        name="viewCentreAdmin"
                        defaultChecked={viewMode === USER_ROLES.CENTRE_ADMIN}
                      />{' '}
                      <span
                        className={classnames(
                          'avatar-menu',
                          styles['avatar-menu'],
                        )}
                      >
                        {i18n.t('centreAdmin')}
                      </span>
                    </Label>
                  </FormGroup>
                </Stylescal>
              </DropdownItem>
            </>
          ) : null}

          {roles?.length > 1 && roles?.indexOf(USER_ROLES.INSTRUCTOR) !== -1 ? (
            <DropdownItem
              tag="a"
              onClick={() => handleChangeMode(USER_ROLES.INSTRUCTOR)}
            >
              <Stylescal>
                <FormGroup check inline>
                  <Label
                    className="profile-display"
                    check
                    // style={{
                    //   color: isInstructor ? menuColor : '',
                    // }}
                    // onMouseEnter={() => handleMouseEnter('instructor-hover')}
                    // onMouseLeave={() => handleMouseLeave('instructor-hover')}
                  >
                    <Input
                      type="radio"
                      name="viewInstructor"
                      defaultChecked={viewMode === USER_ROLES.INSTRUCTOR}
                    />{' '}
                    <span
                      className={classnames(
                        'avatar-menu',
                        styles['avatar-menu'],
                      )}
                    >
                      {i18n.t('instructor')}
                    </span>
                  </Label>
                </FormGroup>
              </Stylescal>
            </DropdownItem>
          ) : null}

          {roles?.length > 1 && roles?.indexOf(USER_ROLES.LEARNER) !== -1 ? (
            <>
              <DropdownItem
                tag="a"
                onClick={() => handleChangeMode(USER_ROLES.LEARNER)}
              >
                <Stylescal>
                  <FormGroup check inline>
                    <Label
                      className="profile-display"
                      check
                      // style={{
                      //   color: isLearner ? menuColor : '',
                      // }}
                      // onMouseEnter={() => handleMouseEnter('learner-hover')}
                      // onMouseLeave={() => handleMouseLeave('learner-hover')}
                    >
                      <Input
                        type="radio"
                        name="viewLearner"
                        defaultChecked={viewMode === USER_ROLES.LEARNER}
                      />{' '}
                      <span
                        className={classnames(
                          'avatar-menu',
                          styles['avatar-menu'],
                        )}
                      >
                        {i18n.t('learner')}
                      </span>
                    </Label>
                  </FormGroup>
                </Stylescal>
              </DropdownItem>
              <hr />
            </>
          ) : null}

          {/* <DropdownItem
            tag="a"
            onClick={() => Router.push('/cms/checkout')}
            className={classnames(
              'profile-item-display',
              'btn-hover-act',
              styles['btn-hover-act'],
              styles['profile-item-display'],
            )}
          >
            <i class="material-icons-outlined" style={{ fontSize: 17 }}>
              paid
            </i>
            <span
              className={classnames(
                'avatar-menu-item',
                styles['avatar-menu-item'],
              )}
            >
              Credit Score
            </span>
          </DropdownItem> */}
          {viewMode === 'LEARNER' && metaData?.cmsFooter && (
            <DropdownItem
              tag="a"
              onClick={() => profileMenuHandler('purchaseHistory-hover')}
            >
              <label
                style={{
                  display: 'flex',
                  color: isPurchaseHistory
                    ? menuColor
                    : router?.pathname === '/homes/purchaseHistory'
                    ? menuColor
                    : '',
                }}
                onMouseEnter={() => handleMouseEnter('purchaseHistory-hover')}
                onMouseLeave={() => handleMouseLeave('purchaseHistory-hover')}
              >
                <MdHistory style={{ height: 18, width: 22 }} />
                <span
                  className={classnames(
                    'avatar-menu-item',
                    styles['avatar-menu-item'],
                  )}
                >
                  Purchase History
                </span>
              </label>
            </DropdownItem>
          )}
          {viewMode === 'ADMIN' && (
            <DropdownItem
              tag="a"
              onClick={() => profileMenuHandler('coupon-hover')}
            >
              <label
                style={{
                  display: 'flex',
                  color: isCoupon
                    ? menuColor
                    : router?.pathname === '/homes/addCoupon'
                    ? menuColor
                    : '',
                }}
                onMouseEnter={() => handleMouseEnter('coupon-hover')}
                onMouseLeave={() => handleMouseLeave('coupon-hover')}
              >
                <MdOutlineLocalActivity className="menu-icon-width" />
                <span
                  className={classnames(
                    'avatar-menu-item',
                    styles['avatar-menu-item'],
                  )}
                >
                  Coupon
                </span>
              </label>
            </DropdownItem>
          )}
          {metaData?.cmsHomePage && viewMode === 'ADMIN' && <hr />}
          {(viewMode === 'ADMIN' || viewMode === 'SUPER_ADMIN') && (
            <>
              <DropdownItem
                tag="a"
                onClick={() => profileMenuHandler('notification-hover')}
              >
                <label
                  style={{
                    display: 'flex',
                    color: isNotification
                      ? menuColor
                      : router?.pathname === '/notification'
                      ? menuColor
                      : '',
                  }}
                  onMouseEnter={() => handleMouseEnter('notification-hover')}
                  onMouseLeave={() => handleMouseLeave('notification-hover')}
                >
                  <MdOutlineNotifications className="menu-icon-width" />
                  <span
                    className={classnames(
                      'avatar-menu-item',
                      styles['avatar-menu-item'],
                    )}
                  >
                    Notification
                  </span>
                </label>
              </DropdownItem>
              {user?.roles?.includes(USER_ROLES.SUPER_ADMIN) && (
                <DropdownItem
                  tag="a"
                  onClick={() => profileMenuHandler('accountSettings-hover')}
                >
                  <label
                    style={{
                      display: 'flex',
                      color: isAccountSetting
                        ? menuColor
                        : router?.pathname === '/account-settings'
                        ? menuColor
                        : '',
                    }}
                    onMouseEnter={() =>
                      handleMouseEnter('accountSettings-hover')
                    }
                    onMouseLeave={() =>
                      handleMouseLeave('accountSettings-hover')
                    }
                  >
                    <MdOutlineSettings style={{ height: 18, width: 22 }} />
                    <span
                      className={classnames(
                        'avatar-menu-item',
                        styles['avatar-menu-item'],
                      )}
                    >
                      Account Settings
                    </span>
                  </label>
                </DropdownItem>
              )}
              <hr />
            </>
          )}
          {/* <DropdownItem
            tag="a"
            // onClick={() => Router.push('/profile')}

            className={classnames(
              'profile-item-display',
              'btn-hover-act',
              styles['btn-hover-act'],
              styles['profile-item-display'],
            )}
          >
            <i class="material-icons-outlined" style={{ fontSize: 17 }}>
              help_outline
            </i>
            <span
              className={classnames(
                'avatar-menu-item',
                styles['avatar-menu-item'],
              )}
            >
              Help
            </span>
          </DropdownItem> */}
          <DropdownItem
            tag="a"
            onClick={() => profileMenuHandler('profile-hover')}
          >
            <label
              style={{
                display: 'flex',
                color: isProfile
                  ? menuColor
                  : router?.pathname === '/profile'
                  ? menuColor
                  : '',
              }}
              onMouseEnter={() => handleMouseEnter('profile-hover')}
              onMouseLeave={() => handleMouseLeave('profile-hover')}
            >
              <MdPersonOutline className="menu-icon-width" />
              <span
                className={classnames(
                  'avatar-menu-item',
                  styles['avatar-menu-item'],
                )}
              >
                {' '}
                {i18n.t('profile')}
              </span>
            </label>
          </DropdownItem>
          <DropdownItem tag="a" onClick={handleLogout}>
            <label
              style={{ display: 'flex', color: isLogout ? menuColor : '' }}
              onMouseEnter={() => handleMouseEnter('logout-hover')}
              onMouseLeave={() => handleMouseLeave('logout-hover')}
            >
              <MdOutlinePowerSettingsNew className="menu-icon-width" />

              <span
                className={classnames(
                  'avatar-menu-item',
                  styles['avatar-menu-item'],
                )}
              >
                {' '}
                {i18n.t('logout')}
              </span>
            </label>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
      {/* <Label
        className="ml-05 mb-0 flexRow align-items-center"
        for="dropdownUser"
      >
        
      </Label> */}
      {tempUserToken ? (
        <Button.Ripple
          id="btn-back-admin"
          className={classnames(
            'btn-icon ml-05',
            styles['btn-return-main-account'],
          )}
          active
          color="flat-secondary"
          onClick={backToAdmin}
        >
          <RotateCcw size={16} />
          <UncontrolledTooltip placement="bottom" target="btn-back-admin">
            Back to Administrator
          </UncontrolledTooltip>
        </Button.Ripple>
      ) : null}
    </div>
  );
};

export default ProfileAvatar;
